import React, { useState } from "react";
import { Form, Slider } from "antd";
import { SubmitFilterBtn } from "../styles";
import { useSearchResults } from "../../../data/useSearchResults";

const FilterRange = ({ filter, onFiltersChange }) => {
  const { selectedFilters } = useSearchResults();
  const [currentValues, setCurrentValues] = useState([]);

  const { facet, values } = filter || {};
  const { min = 0, max = 100000 } = values || {};

  const marks = {
    [min]: `R$${min.toFixed(2).replace(".", ",")}`,
    [max]: `R$${max.toFixed(2).replace(".", ",")}`,
  };

  const priceFormatter = (price) => `R$${price.toString().replace(".", ",")}`;

  const defaultValue = () => {
    const rangeFilterApplied = selectedFilters?.find(
      ({ name }) => name === facet
    );

    if (rangeFilterApplied) {
      const { values } = rangeFilterApplied;
      const appliedMin = values[0];
      const appliedMax = values[1];

      return [appliedMin, appliedMax];
    }

    return [min, max];
  };

  const onSliderChange = (values) => {
    setCurrentValues(values);
  };

  const onButtonSubmit = () => {
    const selectedFilter = [{ name: [facet], value: currentValues }];
    onFiltersChange(selectedFilter, true);
  };

  return (
    <Form.Item name={facet} className="bnly-search__filter-range">
      <Slider
        className="bnly-filter__range-slider"
        defaultValue={defaultValue}
        min={min}
        max={max}
        marks={marks}
        range
        disabled={false}
        onChange={onSliderChange}
        step={1}
        tooltip={{
          formatter: priceFormatter,
        }}
      />

      <SubmitFilterBtn
        className="bnly-search__filter-submit"
        onClick={() => onButtonSubmit()}
      >
        Aplicar Filtro
      </SubmitFilterBtn>
    </Form.Item>
  );
};

export default FilterRange;
